import { createRootRoute, Outlet } from '@tanstack/react-router';
import { ToastProvider } from '@/components/ui/toast';

export const Route = createRootRoute({
  component: () => (
    <ToastProvider>
      <Outlet />
    </ToastProvider>
  ),
});
